import { useCallback, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const EVT = "meetings-changed";
export const notifyMeetingsChanged = () => window.dispatchEvent(new Event(EVT));

// Loads upcoming meetings, re-polls every minute and re-renders countdowns every 30s.
export function useMeetings(enabled = true) {
  const [data, setData] = useState(null);
  const [now, setNow] = useState(Date.now());

  const load = useCallback(async () => {
    try {
      const { data: d } = await api.get("/meetings");
      setData(d);
    } catch {
      setData((d) => d || { meetings: [], forbidden: true });
    }
  }, []);

  useEffect(() => {
    if (!enabled) return undefined;
    load();
    const poll = setInterval(load, 60000);
    const tick = setInterval(() => setNow(Date.now()), 30000);
    window.addEventListener(EVT, load);
    return () => { clearInterval(poll); clearInterval(tick); window.removeEventListener(EVT, load); };
  }, [enabled, load]);

  const rsvp = useCallback(async (id, status) => {
    try {
      await api.post(`/meetings/${id}/rsvp`, { status });
      toast.success(status === "available" ? "Marked: I'm available" : "Marked: Not available");
      notifyMeetingsChanged();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Could not save your answer");
    }
  }, []);

  return { data, now, load, rsvp };
}
